export default __webpack_public_path__ + "static/media/logo-alternate.2651fd3a.svg";